import React from "react";
import { Box, Typography, Link, Stack } from "@mui/material";

export default function Footer() {
  const appVersion = process.env.REACT_APP_APP_VERSION || "unknown";

  return (
    <Box
      component="footer"
      sx={{
        mt: 4,
        py: 2,
        px: 3,
        borderTop: "1px solid",
        borderColor: "divider",
        backgroundColor: "background.paper",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      {/* Left side */}
      <Typography variant="body2" color="text.secondary">
        Version {appVersion}
      </Typography>

      {/* Right side */}
      <Stack direction="row" spacing={2}>
        <Link
          href="#"
          underline="hover"
          color="primary"
          sx={{ cursor: "pointer" }}
        >
          Contact Us
        </Link>

        <Link
          href="#"
          underline="hover"
          color="primary"
          sx={{ cursor: "pointer" }}
        >
          More Info
        </Link>
      </Stack>
    </Box>
  );
}
